import { __extends } from "tslib";
import { Col, Card, Row, Button, Accordion } from 'react-bootstrap';
import React from 'react';
import CardBuscador from './Card';
var CardBuscadorAvanzadoLateral = /** @class */ (function (_super) {
    __extends(CardBuscadorAvanzadoLateral, _super);
    function CardBuscadorAvanzadoLateral(p) {
        var _this = _super.call(this, p) || this;
        _this.permiso = '';
        _this.Avansado = _this.Avansado.bind(_this);
        return _this;
    }
    CardBuscadorAvanzadoLateral.prototype.Avansado = function () {
        return React.createElement(React.Fragment, null);
    };
    CardBuscadorAvanzadoLateral.prototype.render = function () {
        var _this = this;
        var _a = this, Body = _a.Body, Buscador = _a.Buscador, Avansado = _a.Avansado, Title = _a.Title;
        return (React.createElement(Card, { as: Accordion },
            React.createElement(Card.Header, { className: 'bg-info d-flex row' },
                React.createElement(Button, { as: Accordion.Toggle, eventKey: '0', variant: 'default', "data-tip": 'BUSQUEDA DETALLADA', onClick: function () { return _this.setState({ open: !_this.state.open }); } },
                    React.createElement("i", { className: 'fa fa-wrench' })),
                React.createElement(Title, null)),
            React.createElement(Card.Body, null,
                React.createElement(Row, null,
                    React.createElement(Card, { style: { "with": '20%' }, as: Accordion.Collapse, eventKey: '0' },
                        React.createElement(Card.Body, null,
                            React.createElement(Avansado, null))),
                    React.createElement(Card, null,
                        React.createElement(Buscador, null),
                        React.createElement(Col, { md: 12 },
                            React.createElement(Body, null)))))));
    };
    return CardBuscadorAvanzadoLateral;
}(CardBuscador));
export default CardBuscadorAvanzadoLateral;
//# sourceMappingURL=AvanzadoLateral.js.map